import React from 'react';
import { Text } from 'dripsy';

interface ToastTextProps {
  text?: string;
  fontSize: string;
  lineHeight: string;
  letterSpacing: string;
  fontWeight: string;
  isDescription?: boolean;
}

const ToastText: React.FC<ToastTextProps> = ({
  text,
  fontSize,
  lineHeight,
  letterSpacing,
  fontWeight,
  isDescription = false,
}) => {
  if (!text) return null;

  return (
    <Text
      sx={{
        color: 'inherit',
        fontWeight: isDescription ? '400' : fontWeight,
        fontSize,
        lineHeight,
        letterSpacing,
        marginTop: isDescription ? '4px' : undefined,
        display: 'block',
        width: '100%',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
      }}
    >
      {text}
    </Text>
  );
};

export default ToastText;
